import {
  Component,
  Type,
  OnDestroy,
  AfterViewInit,
  ComponentRef,
  ViewChild,
  ComponentFactoryResolver,
  ChangeDetectorRef,
  ElementRef,
  HostListener,
  Inject
} from '@angular/core';
import { Subject } from 'rxjs';
import { InsertionDirective } from './insertion.directive';
import { DialogRef } from './is-dialog-ref';
import { ISDialogStyleHandlerService } from './is-dialog-style-handler.service';
import { DialogConfig, TemplateLayouts } from './is-dialog-config';
import { FormControl } from '@angular/forms';
import { CdkDrag } from '@angular/cdk/drag-drop';

@Component({
  templateUrl: './is-dialog.component.html',
  styleUrls: ['./is-dialog.component.scss']
})
export class ISDialogComponent implements AfterViewInit, OnDestroy {
  @ViewChild('dragHandle') dragBar!: ElementRef;
  componentId: string = '';
  tabId: string = '';
  windowBarId: string = '';
  tabTitleId: string = '';

  editTitle: boolean = false;

  dialogWidth: number | null = null;
  dialogHeight: number | null = null;;

  dragPosition = { x: 0, y: 0 };

  isMinimized: boolean = false;
  isMaximized: boolean = false;

  componentRef!: ComponentRef<any>;
  currentOpacity: number = 1;

  childComponentType!: Type<any>;

  @ViewChild(InsertionDirective) insertionPoint!: InsertionDirective;
  @ViewChild(CdkDrag) cdkDrag!: CdkDrag;


  private readonly _onClose = new Subject<any>();
  public onClose = this._onClose.asObservable();

  auxTitle = new FormControl<any>(null);

  itsOpenClick: boolean = true;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private cd: ChangeDetectorRef,
    public dialogRef: DialogRef,
    public data: DialogConfig,
    private _dialogStyleService: ISDialogStyleHandlerService,
    private _ref: ChangeDetectorRef,
    @Inject('MV_SPINNER_TEMPLATE') public spinnerTemplate: string,
  ) {
  }

  @HostListener('window:click', ['$event'])
  onScreenClick(event: MouseEvent) {
    if (!this.itsOpenClick) {
      //if (this._dialogStyleService.onMouseClick(event.target)) {
      //this.onMinimize();
      //}
    } else {
      this.itsOpenClick = false;
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScreenScroll(event: MouseEvent) {
    let dialog = document.getElementById(this.componentId);
    var clientRect = dialog?.getBoundingClientRect();
    var clientX = clientRect?.left;
    var clientY = clientRect?.top;

    if (clientY && clientY <= 0) {
      //this.dragPosition = { x: clientX ?? 0, y: window.scrollY }
    }

    var dummyComponent = document.getElementById('dummyContainer');

    if (dummyComponent) {
      dummyComponent.style.top = window.scrollY.toString();
    }

    //if (clientY && clientY >= window.inn)
  }

  ngOnInit(): void {
    this.componentId = `dialog-${this.generateUniqueId()}`;
    this.tabId = `tab-${this.generateUniqueId()}`;
    this.windowBarId = `windowBar-${this.generateUniqueId()}`;
    this.tabTitleId = `windowBar-${this.generateUniqueId()}`;
    this._dialogStyleService.addDialog(this.componentId);
    this.isMinimized = !!this.data?.minimized;
    this.dialogRef._attach(this);
  }

  ngAfterViewInit(): void {
    this.loadChildComponent(this.childComponentType);
    this.configureTemplate();
    this.configureDialog();
    this.cd.detectChanges();

    if (this.data?.minimized) {
      setTimeout(() => {
        if (!this.isMinimized) {
          this.onMinimize();
        } else {
          this.onMinimize();
        }
        this.cd.detectChanges();
      }, 0);
    }
  }

  configureTemplate() {
    if (this.data.template) {
      switch (this.data.template) {
        case TemplateLayouts.entities:
          this.data.dialogConfig = {
            dialogColor: 'white',
            dialogBackgroundColor: '#4a74ae',
            iconColor: 'white',
            iconHoverColor: 'grey'
          };

          this.data.tabConfig = {
            tabBackGroundColor: '#4a74ae',
            tabBorderColor: '#4a74ae',
            iconColor: 'white',
            iconHoverColor: 'grey',
            tabColor: 'white'
          };
          break;
        case TemplateLayouts.tickets:
          this.data.dialogConfig = {
            dialogColor: 'white',
            dialogBackgroundColor: '#f9c927',
            iconColor: 'white',
            iconHoverColor: 'grey'
          };

          this.data.tabConfig = {
            tabBackGroundColor: '#f9c927',
            tabBorderColor: '#f9c927',
            iconColor: 'white',
            iconHoverColor: 'grey',
            tabColor: 'white'
          };
          break;
        case TemplateLayouts.leads:
          this.data.dialogConfig = {
            dialogColor: 'white',
            dialogBackgroundColor: '#1abc9c',
            iconColor: 'white',
            iconHoverColor: 'grey'
          };

          this.data.tabConfig = {
            tabBackGroundColor: '#1abc9c ',
            tabBorderColor: '#1abc9c ',
            iconColor: 'white',
            iconHoverColor: 'white',
            tabColor: 'white '
          };
          break;
        case TemplateLayouts.opportunities:
          this.data.dialogConfig = {
            dialogColor: 'white',
            dialogBackgroundColor: '#8e44ad',
            iconColor: 'white',
            iconHoverColor: 'grey'
          };

          this.data.tabConfig = {
            tabBackGroundColor: '#8e44ad ',
            tabBorderColor: '#8e44ad ',
            iconColor: 'white',
            iconHoverColor: 'white',
            tabColor: 'white '
          };
          break;
        case TemplateLayouts.history:
          this.data.dialogConfig = {
            dialogColor: 'white',
            dialogBackgroundColor: '#fe9952',
            iconColor: 'white',
            iconHoverColor: 'grey'
          };

          this.data.tabConfig = {
            tabBackGroundColor: '#fe9952',
            tabBorderColor: '#fe9952',
            iconColor: 'white',
            iconHoverColor: 'white',
            tabColor: 'white '
          };
          break;
        case TemplateLayouts.black:
          this.data.dialogConfig = {
            dialogColor: 'white',
            dialogBackgroundColor: 'black',
            iconColor: 'white',
            iconHoverColor: 'grey'
          };

          this.data.tabConfig = {
            tabBackGroundColor: 'black',
            tabBorderColor: 'black',
            iconColor: '#a1a5b7',
            iconHoverColor: 'white',
            tabColor: 'white'
          };
          break;
        case TemplateLayouts.white:
          this.data.dialogConfig = {
            dialogColor: '#7f8298',
            dialogBackgroundColor: 'white',
            iconColor: 'grey',
            iconHoverColor: 'black'
          };

          this.data.tabConfig = {
            tabBackGroundColor: 'white',
            tabBorderColor: 'grey',
            iconColor: 'grey',
            iconHoverColor: 'black',
            tabColor: 'grey'
          };
          break;
        case TemplateLayouts.primary:
          this.data.dialogConfig = {
            dialogColor: 'white',
            dialogBackgroundColor: '#2F3C4D',
            iconColor: 'rgba(255, 255, 255, 0.2)',
            iconHoverColor: 'white'
          };

          this.data.tabConfig = {
            tabBackGroundColor: '#2F3C4D',
            tabBorderColor: '#2F3C4D',
            iconColor: 'rgba(255, 255, 255, 0.2)',
            iconHoverColor: 'white',
            tabColor: 'white'
          };
          break;
        case TemplateLayouts.grey:
          this.data.dialogConfig = {
            dialogColor: 'white',
            dialogBackgroundColor: 'rgb(145 156 171)',
            iconColor: 'white',
            iconHoverColor: '#545454'
          };

          this.data.tabConfig = {
            tabBackGroundColor: '#929caa',
            tabBorderColor: '#929caa',
            iconColor: 'white',
            iconHoverColor: '#545454',
            tabColor: 'white'
          };
          break;
        case TemplateLayouts.lightPrimary:
          this.data.dialogConfig = {
            dialogColor: 'white',
            dialogBackgroundColor: 'rgb(176 208 251)',
            iconColor: 'white',
            iconHoverColor: '#767676'
          };

          this.data.tabConfig = {
            tabBackGroundColor: 'rgb(176 208 251)',
            tabBorderColor: 'rgb(176 208 251)',
            iconColor: 'white',
            iconHoverColor: '#767676',
            tabColor: 'white'
          };
          break;
        case TemplateLayouts.lightGrey:
          this.data.dialogConfig = {
            dialogColor: 'rgb(128 130 145)',
            dialogBackgroundColor: 'rgb(227 227 227)',
            iconColor: '#7f8298',
            iconHoverColor: 'black'
          };

          this.data.tabConfig = {
            tabBackGroundColor: 'rgb(249 249 249)',
            tabBorderColor: 'rgb(249 249 249)',
            iconColor: '#7f8298',
            iconHoverColor: 'black',
            tabColor: 'rgb(128 130 145)'
          };
          break;
        case TemplateLayouts.bankAccounts:
          this.data.dialogConfig = {
            dialogColor: 'white',
            dialogBackgroundColor: 'rgb(255 86 17)',
            iconColor: 'white',
            iconHoverColor: 'black'
          };

          this.data.tabConfig = {
            tabBackGroundColor: 'rgb(255 86 17)',
            tabBorderColor: 'rgb(255 86 17)',
            iconColor: 'white',
            iconHoverColor: 'black',
            tabColor: 'white'
          };
          break;
        case TemplateLayouts.accessRequests:
          this.data.dialogConfig = {
            dialogColor: 'white',
            dialogBackgroundColor: '#0C6832',
            iconColor: 'white',
            iconHoverColor: 'black'
          };

          this.data.tabConfig = {
            tabBackGroundColor: '#0C6832',
            tabBorderColor: '#0C6832',
            iconColor: 'white',
            iconHoverColor: 'black',
            tabColor: 'white'
          };
          break;
        case TemplateLayouts.darkBlue:
          this.data.dialogConfig = {
            dialogColor: 'white',
            dialogBackgroundColor: '#505DA6',
            iconColor: 'white',
            iconHoverColor: 'grey'
          };

          this.data.tabConfig = {
            tabBackGroundColor: '#505DA6',
            tabBorderColor: '#505DA6',
            iconColor: 'white',
            iconHoverColor: 'grey',
            tabColor: 'white'
          };
          break;
        default:
          break;
      }
    }
  }

  configureDialog(): void {
    let X: number, Y: number;

    // -----------------------------
    // Size (Width / Height)
    // -----------------------------

    // Width: só fixa se vier no config; senão é auto
    if (this.data.width != null) {
      if (this.data.width > window.innerWidth) {
        this.data.width = window.innerWidth;
      }
      this.dialogWidth = this.data.width;
    } else {
      this.dialogWidth = null; // auto
    }

    // Height: só fixa se vier no config; senão é auto
    if (this.data.height != null) {
      if (this.data.height > window.innerHeight) {
        this.data.height = window.innerHeight;
      }
      this.dialogHeight = this.data.height;
    } else {
      this.dialogHeight = null; // auto
    }

    // -----------------------------
    // Position (X / Y)
    // -----------------------------

    // X: se width for auto, ainda não sabemos a width real -> usa fallback e re-centra depois
    if (this.data.initialPositionX != null) {
      X = this.data.initialPositionX;
    } else {
      const fallbackWidth = this.dialogWidth ?? 700; // fallback só para cálculo inicial
      X = window.innerWidth / 2 - fallbackWidth / 2;
    }

    if (this.data.initialPositionY != null) {
      Y = this.data.initialPositionY;
    } else {
      const fallbackHeight = this.dialogHeight ?? 400;
      Y = window.innerHeight / 2 - fallbackHeight / 2;
    }

    // -----------------------------
    // Apply styles / drag position
    // -----------------------------
    const dialog = document.getElementById(this.componentId);
    if (dialog) {
      this.dragPosition = { x: X, y: Y };

      const dialogBar = document.getElementById(this.windowBarId);
      if (dialogBar) {
        dialogBar.style.color = this.data.dialogConfig?.dialogColor ?? 'white';
        dialogBar.style.backgroundColor = this.data.dialogConfig?.dialogBackgroundColor ?? '#2F3C4D';
      }

      const barIcons = dialog.getElementsByClassName('toolbar-buttons');
      const that = this;
      for (let i = 0; i < barIcons.length; i++) {
        (barIcons[i] as HTMLElement).style.color =
          that.data.dialogConfig?.iconColor ?? 'rgba(255, 255, 255, 0.2)';

        (barIcons[i] as HTMLElement).onmouseover = function () {
          (barIcons[i] as HTMLElement).style.color =
            that.data.dialogConfig?.iconHoverColor ?? 'white';
        };

        (barIcons[i] as HTMLElement).onmouseleave = function () {
          (barIcons[i] as HTMLElement).style.color =
            that.data.dialogConfig?.iconColor ?? 'rgba(255, 255, 255, 0.2)';
        };
      }
    }

    // Title
    if (this.data.title) this.auxTitle.setValue(this.data.title);

    // -----------------------------
    // Re-center if width/height is AUTO
    // (only if user didn't set initial positions)
    // -----------------------------
    const shouldRecenterX = this.dialogWidth == null && this.data.initialPositionX == null;
    const shouldRecenterY = this.dialogHeight == null && this.data.initialPositionY == null;

    if (shouldRecenterX || shouldRecenterY) {
      setTimeout(() => {
        const el = document.getElementById(this.componentId);
        if (!el) return;

        const rect = el.getBoundingClientRect();

        const newX = this.data.initialPositionX ?? (window.innerWidth / 2 - rect.width / 2);
        const newY = window.scrollY + (this.data.initialPositionY ?? (window.innerHeight / 2 - rect.height / 2));

        this.dragPosition = { x: newX, y: newY };
        this.cd.detectChanges();
      }, 0);
    }
  }
  configureTab(): void {
    let tab = document.getElementById(this.tabId);
    //Minimized Tab Dialog Style
    if (tab && this.data.tabConfig) {
      tab.style.color = this.data.tabConfig.tabColor;
      tab.style.backgroundColor = this.data.tabConfig.tabBackGroundColor;
      tab.style.borderColor = this.data.tabConfig.tabBorderColor;

      let tabIcons = tab.getElementsByClassName('tab-icon');
      let that = this;
      for (let i = 0; i < tabIcons.length; i++) {
        (tabIcons[i] as HTMLElement).style.color = this.data.tabConfig.iconColor;


        (tabIcons[i] as HTMLElement).onmouseover = function () {
          (tabIcons[i] as HTMLElement).style.color = that.data.tabConfig?.iconHoverColor ?? '';
        };

        (tabIcons[i] as HTMLElement).onmouseleave = function () {
          (tabIcons[i] as HTMLElement).style.color = that.data.tabConfig?.iconColor ?? '';
        };
      }

    }
  }

  ngOnDestroy(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
      this._dialogStyleService.removeMinimizeDialog(this.tabId);
      this._dialogStyleService.removeDialog(this.componentId);
      this.updateTabsPositions();
    }
  }

  loadChildComponent(componentType: Type<any>): void {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);

    let viewContainerRef = this.insertionPoint.viewContainerRef;
    viewContainerRef.clear();

    this.componentRef = viewContainerRef.createComponent(componentFactory);
  }

  maximizeDialog() {
    let dialog = document.getElementById(this.componentId);
    if (dialog) {
      this.isMaximized = !this.isMaximized;

      this.dragPosition = { x: 0, y: 0 };
      dialog.style.width = this.isMaximized ? `100%` : `50%`;
      dialog.style.height = this.isMaximized ? `100%` : `50%`;

      this.updateTabsPositions();
    }
  }

  closeDialog(): void {
    this._onClose.next(null);
    this._dialogStyleService.removeDialog(this.componentId);
    this._dialogStyleService.removeMinimizeDialog(this.tabId);
    this.updateTabsPositions();

    // Se o componente filho expõe, usa isso
    const instance: any = this.componentRef?.instance;
    const result =
      instance && typeof instance.getDialogCloseResult === 'function'
        ? instance.getDialogCloseResult()
        : null;

    this.dialogRef.close(result);
  }


  onMinimize() {
    const startPoint = 10;
    const margin = 5;
    const screenWidth = window.innerWidth;
    const tabWidth = 272;
    const totalDialogs = this._dialogStyleService.minimizedDialogs.length;
    const offSetLeft = startPoint + (margin + tabWidth) * totalDialogs;
    if (offSetLeft > screenWidth) {
      return;
    }

    this.isMinimized = true;
    this._dialogStyleService.minimizeDialog(this.tabId);

    setTimeout(() => {
      let tab = document.getElementById(this.tabId);
      this.configureTab();
      if (tab) {
        if (totalDialogs > 0) {
          tab.style.left = offSetLeft + 'px';

        } else {
          tab.style.left = '10px';
        }
      }
    }, 1);
  }

  updateTabsPositions() {
    const startPoint = 10;
    const screenWidth = window.innerWidth;
    const tabWidth = 272;

    this._dialogStyleService.minimizedDialogs.forEach(function (tab, index) {
      let tabElement = document.getElementById(tab);
      const offSetLeft = startPoint + (tabWidth + 5) * (index);
      if (tabElement) {
        if (index == 0) {
          tabElement.style.left = '10px';
        } else {
          tabElement.style.left = offSetLeft + 'px';
        }
      }

    });
  }

  onDialogClicked() {
    this._dialogStyleService.updateZindex(this.componentId);
  }

  onDragStart(ev: any) {
    this._dialogStyleService.updateZindex(this.componentId);
    let dialogBar = document.getElementById(this.windowBarId);
    if (dialogBar) {
      dialogBar.style.cursor = 'grabbing';
    }
  }

  onDragEnd(ev: any) {

    let dialogBar = document.getElementById(this.windowBarId);

    if (dialogBar) {
      dialogBar.style.cursor = 'grab';
    }

    let dialog = document.getElementById(this.componentId);
    if (dialog) {
      let pos = dialog.getBoundingClientRect();
      this.dragPosition = { x: pos.x, y: pos.y };
    }

    const containerElement = document.getElementById('dummyContainer');

    if (containerElement) {
      const containerWidth = containerElement.clientWidth;
      const containerHeight = containerElement.clientHeight;

      if (ev.dropPoint.x < 0) {
        //this.dragPosition = { x: window.innerWidth / 2, y: window.innerHeight / 2 }
      }


      if (ev.dropPoint.y < 0) {
        //this.dragPosition = { x: window.innerWidth / 2, y: window.innerHeight / 2 }
      }
    }
  }

  onOpacityChange(event: any) {
    let dialog = document.getElementById(this.componentId);
    this.currentOpacity = 1 - event / 100;
    if (this.currentOpacity > 0.96) {
      this.currentOpacity = 1;
    }
    if (dialog) {
      dialog.style.opacity = this.currentOpacity.toString();
    }
    this._ref.detectChanges();
  }

  generateUniqueId(): string {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
  }

  moveDialogToTopRight() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    this.dialogWidth = screenWidth / 2;
    this.dialogHeight = screenHeight / 2;

    setTimeout(() => {
      let dialog = document.getElementById(this.componentId);
      if (dialog) {
        const dialogWidth = dialog.offsetWidth;
        const dummy = document.createElement('div');
        dummy.style.position = 'absolute';
        dummy.style.top = '-9999px';
        dummy.style.width = '50px';
        dummy.style.height = '50px';
        dummy.style.overflow = 'scroll';
        document.body.appendChild(dummy);

        const scrollbarWidth = dummy.offsetWidth - dummy.clientWidth;
        document.body.removeChild(dummy);

        const hasVScroll = document.body.scrollHeight > document.body.clientHeight;

        const newX = screenWidth - dialogWidth - (hasVScroll ? scrollbarWidth : 0);
        const newY = window.scrollY; // Adjusted for scroll position
        this.dragPosition = { x: newX, y: newY };
      }
    }, 10);
  }

  moveDialogToTopLeft() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    this.dialogWidth = screenWidth / 2;
    this.dialogHeight = screenHeight / 2;

    this.dragPosition = { x: 0, y: window.scrollY }; // Adjusted for scroll position
  }

  moveDialogToBottomLeft() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    this.dialogWidth = screenWidth / 2;
    this.dialogHeight = screenHeight / 2;

    const newY = screenHeight - this.dialogHeight + window.scrollY; // Adjusted for scroll position
    this.dragPosition = { x: 0, y: newY };
  }

  moveDialogToBottomRight() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    this.dialogWidth = screenWidth / 2;
    this.dialogHeight = screenHeight / 2;

    const newX = screenWidth - this.dialogWidth;
    const newY = screenHeight - this.dialogHeight + window.scrollY; // Adjusted for scroll position
    this.dragPosition = { x: newX, y: newY };
  }

  moveDialogToLeft() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    this.dialogWidth = screenWidth / 2;
    this.dialogHeight = screenHeight;

    this.dragPosition = { x: 0, y: window.scrollY }; // Adjusted for scroll position
  }

  moveDialogToRight() {
    const screenWidth = window.innerWidth;

    setTimeout(() => {
      const dialog = document.getElementById(this.componentId);
      if (!dialog) return;

      const dummy = document.createElement('div');
      dummy.style.position = 'absolute';
      dummy.style.top = '-9999px';
      dummy.style.width = '50px';
      dummy.style.height = '50px';
      dummy.style.overflow = 'scroll';
      document.body.appendChild(dummy);

      const scrollbarWidth = dummy.offsetWidth - dummy.clientWidth;
      document.body.removeChild(dummy);

      const hasVScroll = document.body.scrollHeight > document.body.clientHeight;

      // ✅ largura real do dialog (se dialogWidth for null/auto, isto resolve)
      const dialogWidth = dialog.getBoundingClientRect().width || this.dialogWidth || 700;

      const newX = screenWidth - dialogWidth - (hasVScroll ? scrollbarWidth : 0);
      const newY = window.scrollY;

      this.dragPosition = { x: newX, y: newY };
      this.cd.detectChanges();
    }, 10);
  }


  reopenDialog() {
    this.isMinimized = false;
    this.editTitle = false;

    this._dialogStyleService.removeMinimizeDialog(this.tabId);
    this.updateTabsPositions();
    this.onDialogClicked();
  }

  changeTitle(event?: Event) {
    event?.stopPropagation();
    this.editTitle = true;

    let tabTitle = <HTMLInputElement>document.getElementById(this.tabTitleId + "input");
    if (tabTitle) {
      tabTitle.click();
      tabTitle.focus();

    }
  }

  /**
   * Saves the dialog title change
   */
  saveTitleChange() {
    // Casts the HTML element found to a HTMLInputElement to be able to access its value
    let tabTitle = <HTMLInputElement>document.getElementById(this.tabTitleId + "input");
    if (tabTitle) {
      this.data.title = tabTitle.value;
    }
    this.editTitle = false;
  }

  onTitleChange(value: any) {
    this.data.title = value;
  }

  onVisibilityClick() {
    setTimeout(() => {
      const progressBar = document.querySelector('.mat-mdc-progress-bar') as HTMLElement;
      if (progressBar) {
        progressBar.style.setProperty('--mdc-linear-progress-active-indicator-color', 'red');
      }
    }, 20);

  }

  onDummyContainerClick(ev: any) {

  }
}